import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import utils from 'src/utils';
import featureFlags from 'src/featureFlags';

const { roundAndFormatNumber } = utils.measure;

export default class MeasureNumber extends PureComponent {
  static propTypes = {
    number: PropTypes.number.isRequired,
    isSquare: PropTypes.bool.isRequired,
    unit: PropTypes.string.isRequired,
  };

  render() {
    const { number, isSquare, unit } = this.props;

    return (
      <div data-selenium="measureNumberText">
        {roundAndFormatNumber(number, unit, true)}
        {isSquare && <sup>2</sup>}
      </div>
    );
  }
}
